// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/3925
import type { PAPEventGeneric } from "../base/event";
import type { TooltipName } from "../enums/tooltip_name";
import type { Environment } from "../enums/environment";
import type { DashSurfaceBuild } from "../enums/dash_surface_build";
import type { DashUser } from "../enums/dash_user";

// Event_name: 'dismiss.dash_tooltip'
// Description: fired when a user explicitly dismisses an onboarding tutorial tooltip using the (x) cta on the modal
// Owner: otc-growth
export type Dismiss_DashTooltip = PAPEventGeneric<
  'dash',
  'dismiss',
  'dash_tooltip',
  {
    // the start time of the event in ms
    startTimeMs?: number;
    // properties to desccribe the onboarding tooltip that pops up
    tooltipName?: TooltipName;
    // Whether the app dispatching the event is Prod, Test, or Dev (run locally by the developer)
    environment?: Environment;
    // Number of items in the operating set for a workflow instance
    operatingSetSize?: number;
    // Defines different types of dash surfaces
    dashSurfaceBuild?: DashSurfaceBuild;
    // generic property representing build version of whatever is logging this event.
    buildVersion?: string;
    // A unique identifier associated with a specific installation of a specific product. This is unique per install but not per user, as a user may have multiple installations of a given product (reinstalls, multiple devices). Per drl/data_classification, this is L2 Data ("Dropbox-assigned device ID").
    installId?: string;
    // Device id for Replay events so that we can distinguish between logged out users.
    deviceId?: string;
    // Identifies type of Dash user
    dashUser?: DashUser;
  }
>;

export function PAP_Dismiss_DashTooltip(properties?: Dismiss_DashTooltip['properties']): Dismiss_DashTooltip {
  return <Dismiss_DashTooltip>{
    class: 'dash',
    action: 'dismiss',
    object: 'dash_tooltip',
    properties,
  };
}